<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Recurring Invoice Audit Trail</span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="form">

            <div class="row d-flex justify-content-center mb-2 align-items-center flex-wrap grid-margin">
                <div class="col-md-4">
                    <div class="table_search">
                        <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'">
                            <mat-label>Search</mat-label>
                            <div class="search-input-container">
                                <input placeholder="Enter Report Name / Recurring month" id="search"
                                    formControlName="searchquery" matInput (keyup)="applyFilter($event)" type="text"
                                    #searchInput>
                            </div>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-md-2">
                    <!-- <button type="button" matRipple class="btn btn-secondary" (click)="getData()">
                        <i class="fa fa-refresh"></i> Refresh
                    </button> -->
                <app-button (refreshClicked)="getData()"></app-button>

                </div>

            </div>
            <div class="table-responsive mt-2">
                <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">

                    <ng-container matColumnDef="reportName">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="reportName">Report Name</mat-header-cell>
                        <mat-cell *matCellDef="let dataField">
                            <p class="text-truncate txtalign">
                                {{dataField.reportName}}</p>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</mat-header-cell>
                        <mat-cell *matCellDef="let dataField">
                            <p class="text-truncate txtalign badge badge_style"
                                [style.--badgeCol]="badgeCol(dataField.status)">
                                {{dataField.status}}</p>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="transDate">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="transDate">Recurring month</mat-header-cell>
                        <mat-cell *matCellDef="let dataField">
                            <p class="text-truncate txtalign">{{formatDate(dataField.transDate)}}</p>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="totalAmount">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="totalAmount">Batch Value</mat-header-cell>
                        <mat-cell *matCellDef="let dataField">
                            <p class="text-truncate txtalign">
                                {{dataField.totalAmount}}</p>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Action">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="Action">Action</mat-header-cell>
                        <mat-cell *matCellDef="let dataField">
                            <p class="text-truncate d-flex text-center justify-content-center" title="Download Invoice">
                                <svg style="cursor: pointer; color: #9a00da;" (click)="download(dataField)" width="24"
                                    height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11L12 16ZM6 20C5.45 20 4.97933 19.8043 4.588 19.413C4.19667 19.0217 4.00067 18.5507 4 18V15H6V18H18V15H20V18C20 18.55 19.8043 19.021 19.413 19.413C19.0217 19.805 18.5507 20.0007 18 20H6Z"
                                        fill="#9a00da" />
                                </svg>
                            </p>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                    <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                    </mat-row>
                </mat-table>
            </div>

            <div class="table_pagenation">
                <mat-paginator #paginator [length]="dataSource!==null && dataSource.filteredData.length" [pageIndex]="0"
                    [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]">
                </mat-paginator>
            </div>
        </form>

    </div>
</div>